import { userService } from '@/_services'
import router from '../../router/index'

const user = JSON.parse(localStorage.getItem('user'))
const initialState = user ? { status: { loggedIn: true }, user } : { status: {}, user: null }

export const authentication = {
    namespaced: true,
    state: initialState,
    // state: {
    //     user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
    //     status: localStorage.getItem('user') ? { loggedIn: true } : {},
    //     accessToken: null,
    //     exp: null
    // },
    getters: {
        getUser: (state) => {
            return state.user
        }
    },
    actions: {
        login({ dispatch, commit }, { email, passwordjwt }) {
            commit('loginRequest', { email });
            userService.login(email, passwordjwt)
                .then(
                    user => {
                        commit('loginSuccess', user);
                        router.push('/');
                    },
                    error => {
                        commit('loginFailure', error);
                        dispatch('alert/error', error, { root: true });
                    }
                );
        },
        logout({ commit }) {
            userService.logout();
            commit('logout');
            localStorage.clear()
        }
    },
    mutations: {
        setToken(state, token) {
            state.accessToken = token;
        },
        setUser(state, user) {
            state.user = user;
        },
        loginRequest(state, user) {
            state.status = { loggingIn: true };
            state.user = user;
        },
        loginSuccess(state, user) {
            state.status = { loggedIn: true };
            state.user = user;
        },
        loginFailure(state) {
            state.status = {};
            state.user = null;
        },
        logout(state) {
            state.status = {};
            state.user = null;
        }
    }
};